<template>
  <div>
    <div v-on:click.self="close()" v-bind:style="theStyle" class="modal fade" v-bind:class="theStyleClass" tabindex="-1"
         role="dialog">
      <div class="modal-dialog" v-bind:class="modalDialogClass" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ title }}</h4>
            <button type="button" v-on:click.prevent="close()" class="btn-close"></button>
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
          <div v-if="footer" class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal",
  props: ["open", "title", "closeLabel", "size"],
  data: function () {
    return {
      theStyle: "display: none;",
      theStyleClass: "",
      backdrop: null
    }
  },
  computed: {
    modalDialogClass: function () {
      switch (this.size) {
        case "sm":
          return "modal-sm";
        case "lg":
          return "modal-lg";
        case "xl":
          return "modal-xl";
        default:
          return ""
      }
    },
    footer: function () {
      return !!this.$slots.footer
    }
  },
  created: function () {
    var instance = this
    document.addEventListener("keydown", function (event) {
      if (event.keyCode == 27) {
        instance.close()
      }
    })
  },
  watch: {
    open: function (newValue/*, oldValue*/) {
      var instance = this
      if (newValue == true) {
        document.body.classList.add("modal-open")
        instance.backdrop = document.createElement("div")
        instance.backdrop.classList.add("modal-backdrop", "fade")
        document.body.appendChild(instance.backdrop)
        instance.theStyle = "display: block"
        setTimeout(function () {
          instance.backdrop.classList.add("show")
          instance.theStyleClass = "show"
        }, 0)
      } else {
        instance.theStyleClass = ""
        instance.backdrop.classList.remove("show")
        // instance.backdrop.style.display = "0"; // possible, but poor ie11 (blackness) fix
        setTimeout(function () {
          document.body.classList.remove("modal-open")
          if (instance.backdrop != null) {
            document.body.removeChild(instance.backdrop)
            instance.backdrop = null
          }
          instance.theStyle = "display: none"
        }, 150) // .15s is the animation length of the 'fade' style class
      }
    }
  },
  methods: {
    close: function () {
      this.$emit("close")
    }
  }
}
</script>
